export default function slashSeparatedISODateToISODate(ssIsoDate) {
    return ssIsoDate.replace(/[/]/g, '-');
}
